// app/javascript/controllers/carousel_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];
  static values = { currentIndex: Number };

  connect() {
    this.updateCarousel();
  }

  previous() {
    this.currentIndexValue = (this.currentIndexValue - 1 + this.itemTargets.length) % this.itemTargets.length;
    this.updateCarousel();
  }

  next() {
    this.currentIndexValue = (this.currentIndexValue + 1) % this.itemTargets.length;
    this.updateCarousel();
  }

  updateCarousel() {
    this.itemTargets.forEach((item, index) => {
      item.classList.toggle(
        "hidden",
        index !== this.currentIndexValue
      );
    });
  }

  navigate({params: {newIndex}}) {
    this.currentIndexValue = newIndex;
    this.updateCarousel()
  }
}